import type { QueryClient } from '@tanstack/react-query';

export const PHOTO_STALE_TIME = 5 * 60 * 1000;

// A photo can appear in several tabs. Refresh every view after a write, while
// retaining cached metadata across ordinary tab switches.
export async function invalidatePhotoQueries(
  client: QueryClient,
  scope: { venueId?: string | null; eventId?: string | null },
) {
  const keys = [
    ...(scope.venueId ? [
      ['venue-field-photos', scope.venueId],
      ['venue-note-photos', scope.venueId],
      ['venueRoomPhotos', scope.venueId],
      ['venueRoomPhotoCounts', scope.venueId],
    ] : []),
    ...(scope.eventId ? [
      ['event-photos', scope.eventId],
      ['summary-photos', scope.eventId],
      ['eventRoomPhotos', scope.eventId],
      ['eventRoomPhotoCounts', scope.eventId],
    ] : []),
  ];
  await Promise.all([
    ...keys.map(queryKey => client.invalidateQueries({ queryKey })),
    client.invalidateQueries({
      queryKey: ['logistics-photos'],
      predicate: query => scope.eventId
        ? query.queryKey[1] === scope.eventId
        : query.queryKey[1] === null && query.queryKey[2] === scope.venueId,
    }),
  ]);
}
